import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLogger } from 'services/Logger';
import { Row } from 'components/ui/Grid';
import TextArea from 'components/ui2/TextArea';
import {
  AccordionCard,
} from 'components/pages/SchedaEntePage/shared';
import { ListAttachment } from './listattachment';
import { Socials } from './socials';

const AttachmentsSectionComponent = ({
  dataset = {},
  disabled = {},
  errors = {},
  handleFieldBlur,
  isAdmin,
  keySection,
  setDataset,
  touched = {},
}) => {
  const logger = useLogger();

  useEffect(() => {
    logger.log(keySection, dataset);
  }, [dataset]);

  const setFormFieldAttachments = (key, value) => {
    const form = {
      ...dataset,
      [key]: value,
    };
    setDataset(keySection, form);
  };

  return (
    <AccordionCard title="Logo, allegati e web">
      <ListAttachment
        dataset={dataset}
        disabled={disabled.section}
        errors={errors}
        handleFieldBlur={handleFieldBlur}
        keySection={keySection}
        setFormFieldAttachments={setFormFieldAttachments}
        touched={touched}
      />
      <Socials
        dataset={dataset}
        disabled={disabled.section}
        errors={errors}
        handleFieldBlur={handleFieldBlur}
        keySection={keySection}
        setFormFieldAttachments={setFormFieldAttachments}
        touched={touched}
      />
      {dataset.note4 || isAdmin ? (
        <Row fluid margin="2em 0 0 0">
          <TextArea
            bgColor="lightYellow"
            disabled={disabled.notes}
            inputValue={dataset.note4}
            label="Indicazioni della redazione WeMi"
            onChange={(newValue) => {
              setFormFieldAttachments('note4', newValue);
            }}
          />
        </Row>
      ) : null}
    </AccordionCard>
  );
};

AttachmentsSectionComponent.displayName = 'Description section';

AttachmentsSectionComponent.propTypes = {
  dataset: PropTypes.shape({
    documents: PropTypes.objectOf(
      PropTypes.shape({
        domain: PropTypes.string,
        fieldName: PropTypes.string,
        file: PropTypes.string,
        isRequired: PropTypes.bool,
        name: PropTypes.string,
        size: PropTypes.number,
        type: PropTypes.string,
      })
    ),
    logo: PropTypes.shape({
      file: PropTypes.string,
      name: PropTypes.string,
      size: PropTypes.number,
      type: PropTypes.string,
    }),
    note4: PropTypes.string,
  }),
  disabled: PropTypes.shape({
    notes: PropTypes.bool,
    section: PropTypes.bool,
  }),
  errors: PropTypes.shape({
    documents: PropTypes.objectOf(PropTypes.object),
    logo: PropTypes.string,
    note4: PropTypes.string,
  }),
  handleFieldBlur: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
  keySection: PropTypes.string.isRequired,
  setDataset: PropTypes.func.isRequired,
  touched: PropTypes.shape({
    documents: PropTypes.objectOf(PropTypes.object),
    logo: PropTypes.bool,
    note4: PropTypes.bool,
  }),
};

export const AttachmentsSection = React.memo(AttachmentsSectionComponent);
